import { Controller } from "@hotwired/stimulus"

// Connects to the data-controller="control-action-button"
export default class extends Controller {
  static targets = ["input", "button"]

  connect() {
    this.updateButtonState = this.updateButtonState.bind(this)
    this.updateButtonState()
    this.inputTargets.forEach(input => {
      input.addEventListener("input", this.updateButtonState)
      input.addEventListener("change", this.updateButtonState)
    })
  }

  disconnect() {
    this.inputTargets.forEach(input => {
      input.removeEventListener("input", this.updateButtonState)
      input.removeEventListener("change", this.updateButtonState)
    })
  }

  inputTargetConnected(input) {
    this.updateButtonState()
    input.addEventListener("input", this.updateButtonState)
    input.addEventListener("change", this.updateButtonState)
  }

  updateButtonState() {
    const allInputsFilled = !!this.inputTargets?.every(input => input.value.trim() !== "")
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = !allInputsFilled
    }
  }
}
